import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import type { JSX } from "react"

export default function PrivacyPolicy (): JSX.Element {
  return (
    <>
    <Row className='mb-3'>
      <Col xs={12}>
        <div className='p-3 p-md-4 p-lg-5 bg-primary text-white br-3'>
          <div className='px-0 px-sm-2 py-5 p-lg-5'>
            <h1 style={{fontWeight: 600}}>
              Referral program
            </h1>
          </div>
        </div>
      </Col>
    </Row>
    <Row className='py-5'>
      <Col xs={12}>
        <div className='px-2 px-lg-4'>
          <p className='pb-4'>
            The referral program allows Ivy Flip users to earn up to 20% recurring revenue from the payments made by new users they refer.
            The percentage of revenue earned is tiered based on the number of successful referrals made by a user.
          </p>

          <h2 className="mt-5">Referral Tiers and Earnings</h2>
          <ul>
            <li>Tier 1: Users earn 10% recurring revenue for referring up to 5 active customers.</li>
            <li>Tier 2: Users earn 15% recurring revenue for referring between 6 to 10 active customers.</li>
            <li>Tier 3: Users earn 20% recurring revenue for referring 10 or more active customers.</li>
          </ul>

          <p>* Earnings are not time limited. Users earn revenue for the lifetime of the referral, so long as the referral maintains a paid Ivy Flip subscription without a lapse in activity.</p>
          <p>** Tiers are based on concurrent and active subscriptions. Users may drop down tiers if the number of concurrent and active referrals decreases from tier to tier.</p>

          <h2 className="mt-5">Eligibility and Payouts</h2>
          <ul>
            <li>A referral is considered successful when the referred customer completes a purchase through a personalized Plans & Pricing page, which is linked to the referrer's user ID.</li>
            <li>The referrer earns their respective percentage every time their referred customer makes a payment.</li>
            <li>Referral bonuses are calculated and paid out on a monthly basis.</li>
          </ul>

          <h2 className="mt-5">Referral Program FAQ</h2>

          <h4 className="mt-4">What is the Ivy Flip Referral Program?</h4>
          <p>
            The Ivy Flip Referral Program is an opportunity for our users to earn recurring revenue by referring new customers to our app.
            When your referrals sign up and make a purchase through your unique referral link, you earn a percentage of their payments as a thank you from us.
          </p>

          <h4 className="mt-4">How do I participate in the Referral Program?</h4>
          <p>
            To participate, simply navigate to the referral section in the settings area of your Ivy Flip mobile app or on our website. Here, you will find your unique referral link which you can share with your friends, family, or network.
          </p>

          <h4 className="mt-4">How much can I earn through referrals?</h4>
          <p>
            Your earnings depend on the number of successful referrals you make:
            <br/>Tier 1: Earn 10% recurring revenue for up to 5 active referrals.
            <br/>Tier 2: Earn 15% recurring revenue for 6 to 10 active referrals.
            <br/>Tier 3: Earn 20% recurring revenue for 10 or more active referrals.
          </p>

          <h4 className="mt-4">How is a referral considered successful?</h4>
          <p>A referral is successful when the person you referred makes a purchase through your unique referral link, accessing the Plans & Pricing page tied to your user ID.</p>

          <h4 className="mt-4">When and how are referral earnings paid out?</h4>
          <p>Referral earnings are based your referral earning tiers and number of active referrals. Referral earnings are calculated at the end of each month and paid out within the first week of the following month. Payments are made directly to the bank account or payment method associated with your Ivy Flip account. (How do we make payments?)</p>

          <h4 className="mt-4">Can I track my referrals and earnings?</h4>
          <p>Yes, in the referral section of the app or website, you will have access to a dashboard where you can track the number of your referrals, their subscription status, and your earned and upcoming payouts.</p>

          <h4 className="mt-4">Do changes in the Plans & Pricing affect my referral link?</h4>
          <p>No, your referral link remains the same. However, the Plans & Pricing page it directs to will automatically update to reflect any changes made to our main Plans & Pricing page, ensuring your referrals always see the latest offerings.</p>

          <h4 className="mt-4">Is there a limit to how many people I can refer?</h4>
          <p>There is no cap on the number of referrals you can make. The more successful referrals you have, the more you can earn, especially as you move into higher tiers with higher percentage earnings.</p>

          <h4 className="mt-4">How long can I earn revenue on a referral?</h4>
          <p>There is no cap to how long you can earn referral revenue. As long as your referral maintains an active paid Ivy Flip subscription without lapse, you will continue to earn referral revenue.</p>

          <h4 className="mt-4">What happens if my referral cancels their subscription?</h4>
          <p>If a referral cancels their subscription or fails to make a payment, this is considered a lapse and you will no longer receive recurring revenue from that referral's payments. Your earnings are tied to the active subscriptions of your referrals.</p>

          <h4 className="mt-4">How does Ivy Flip prevent referral fraud?</h4>
          <p>We have implemented robust security measures to detect and prevent fraudulent activities. This includes monitoring for suspicious behaviors such as the use of fake accounts or manipulation of referral links. We take fraud very seriously and will take appropriate actions if fraudulent activities are detected.</p>

          <h4 className="mt-4">Where can I find more information or get help?</h4>
          <p>
            If you have further questions or need assistance with the Referral Program,
            please reach out to our support team at <a href="mailto:hello@ivyflip.com">hello@ivyflip.com</a>.
            We're here to help make your referral experience as smooth and rewarding as possible.
          </p>
        </div>
      </Col>
    </Row>
    </>
  )
}
